import {CesiumAdapterService} from '../../services/cesiumAdapter21/cesium-adapter.service';

import {ItemsTile} from './ItemsTile';
import {Label} from './ItemsTileItem/Label';
import {ItemsTilesService} from './ItemsTilesService';
import {ItemsTileImageryProvider} from './ItemsTileImageryProvider';
import {ItemsManagerInterface} from '../ItemsManager/ItemsManagerInterface';

export class ItemsTilesManager implements ItemsManagerInterface {
  private static readonly IS_USE_IMAGERY_PROVIDER = true;

  private itemTilesService?: ItemsTilesService = undefined;
  private isDrawn = false;

  private cesiumAdapterService: CesiumAdapterService = undefined;

  constructor(cesiumAdapterService) {
    this.cesiumAdapterService = cesiumAdapterService;
    this.itemTilesService = new ItemsTilesService();

    // if (window['DEMO_DATA']) {
    //   const count = 15000;
    //   this.createTestItems(0, count, 36.124444502801, -5.3751390794872, 0.1);
    //   this.createTestItems(count,  count, 51.498332000000, -0.1455600000000, 0.020);
    // }

    this.cesiumAdapterService.viewer.imageryLayers.layerAdded.addEventListener(this.layerAddedListener, this);
    // this.cesiumAdapterService.viewer.imageryLayers.layerShownOrHidden.addEventListener(this.layerShownOrHiddenListener, this);
  }

  private createTestItems(start,  count, latitude, longitude, area) {
    const leftBottom = {latitude, longitude};
    const styles = ['default', 'ebony', 'vanilla', 'primary', 'white', 'black'];

    for (let i = 0; i < count; i++) {
      this.setItem({
        id: (i + start).toString(),
        position: {latitude: leftBottom.latitude + Math.random() * area, longitude: leftBottom.longitude + Math.random() * area},
        anchor: Label.CENTER,
        value: 'Label ' + i,
        style: styles[ Math.floor(Math.random() * 6 - 0.01) ],
      });
    }

    this.setItem({
      id: 'items count',
      position: {latitude: leftBottom.latitude - 0.00035, longitude: leftBottom.longitude - 0.00035},
      anchor: Label.CENTER,
      value: 'All memory tiles count: ' + this.itemTilesService.getTilesCount(),
    });

  }

  // public layerShownOrHiddenListener(layer, n) {
  //   console.log('[ITEMS CANVAS] layerShownOrHiddenListener', layer, n, layer.show);
  // }

  public layerAddedListener(layer, n) {
    if (layer.imageryProvider instanceof ItemsTileImageryProvider) {
      // layer.show = true;

      const oldLayer = this.cesiumAdapterService.itemsTilesLayer;
      this.cesiumAdapterService.itemsTilesLayer = layer;

      // this.waitForRenderAndDeleteLayer(oldLayer);

      // this.cesiumAdapterService.viewer.imageryLayers.remove(oldLayer, true);

      setTimeout(() => {
            this.cesiumAdapterService.viewer.imageryLayers.remove(oldLayer, true);
            console.log('[ITEMS CANVAS] imageryLayers.remove');
          },
          300
      );
      console.log('[ITEMS CANVAS] layerAddedListener', layer, n, layer.imageryProvider instanceof ItemsTileImageryProvider);
    }
  }

  private async waitForRenderAndDeleteLayer(oldLayer) {
    let timeOut = 0;
    while (window['onemapTilesLoaded'] === false && timeOut < 5000) {
      timeOut += 20;
      await new Promise(r => setTimeout(r, 20));
    }

    this.cesiumAdapterService.viewer.imageryLayers.remove(oldLayer, true);
    console.log('[ITEMS CANVAS] imageryLayers.remove');
  }

  public hasItem(id) {
    return this.itemTilesService.hasItem(id);
  }

  public hasTile(x, y) {
    return this.itemTilesService.hasTile(x, y);
  }

  public setItem(itemConfig) {
    const item = new Label(itemConfig);
    const itemId = item.getId();

    const curItem = this.itemTilesService.getItem(itemId);
    if (curItem && curItem.isEqual(item)) {
      return true;
    }

    if (curItem) {
      this.deleteItemById(itemId);
    }

    this.itemTilesService.setItem(item);
    this.drawTiles(
      this.itemTilesService.getTilesForItem(itemId)
    );
  }

  public hideItemByValue(itemConfig) {
    this.deleteItemByValue(itemConfig);
  }

  public deleteItemByValue(itemConfig) {
    const item = new Label(itemConfig);

    //TODO: possible create static function getIdFromConfig to not create an object
    const itemId = item.getId();
    this.deleteItemById(itemId, true);
  }

  private deleteItemById(id, needDraw = false) {
    if (this.itemTilesService.hasItem(id)) {
      const itemsTiles = this.itemTilesService.getTilesForItem(id);
      this.itemTilesService.deleteItem(id);

      if (itemsTiles && !ItemsTilesManager.IS_USE_IMAGERY_PROVIDER || needDraw) {
        this.drawTiles(itemsTiles);
      }
    }
  }

  public drawXYTile(context, x, y, offsetX, offsetY) {
    const tile = this.itemTilesService.getTile(x, y);
    if (tile) {
      this.drawTile(context, tile, offsetX, offsetY);
    }
  }

  public drawTile(context, tile : ItemsTile, offsetX = 0, offsetY = 0) {
    for (const item of tile.getItems()) {
      item.draw(context, tile, offsetX, offsetY);
    }
  }

  private drawTilesUsingImageryProvider(tiles: IterableIterator<ItemsTile>) {
    if (this.cesiumAdapterService.itemsTilesLayer) {
      console.log('[ITEMS CANVAS] drawTilesUsingImageryProvider', this.cesiumAdapterService.itemsTilesLayer.imageryProvider);

      const layer = new Cesium.ImageryLayer(new ItemsTileImageryProvider(this.cesiumAdapterService) /*, {show: false}*/);
      this.cesiumAdapterService.viewer.imageryLayers.add(layer);
    }
  }

  public drawTiles(tiles: IterableIterator<ItemsTile>) {
    if (this.isDrawn) {
      if (ItemsTilesManager.IS_USE_IMAGERY_PROVIDER) {
        this.drawTilesUsingImageryProvider(tiles);
      } else {
        this.drawTilesUsingEntities(tiles);
      }
    }
  }

  private drawTilesUsingEntities(tiles) {
    const viewer = this.cesiumAdapterService.viewer;

    for (const tile of tiles) {
      // const canvas = tile.getCanvas();
      // const context = tile.getContext();
      // context.clearRect(0, 0, ItemsTile.SIZE, ItemsTile.SIZE);

      const canvas = document.createElement('canvas');
      canvas.width = ItemsTile.SIZE;
      canvas.height = ItemsTile.SIZE;
      const context = canvas.getContext("2d");

      // context.beginPath();
      // context.fillStyle = 'rgba(0, 0, 255, 0.15)';
      // context.fillRect(0, 0, ItemsTile.SIZE, ItemsTile.SIZE);

      this.drawTile(context, tile);

      let entity = viewer.entities.getById(tile.getId());
      if (tile.getId() && entity) {

        // context.fillStyle = 'blue';
        // context.fillRect(0, 0, ItemsTile.SIZE, ItemsTile.SIZE);

        entity.rectangle.material = canvas;
      } else {
        entity = viewer.entities.add({
          name: 'TileItems ' + tile.getKey(),
          rectangle: {
            coordinates: tile.getRectangle(),
            material: canvas,
            // scale: 1,
            // classificationType: Cesium.ClassificationType.TERRAIN,
          },
        });

        tile.setId(entity.id);
      }
    }

    this.cesiumAdapterService.viewer.scene.requestRender();
  }

  public drawAll() {
    if (!this.isDrawn) {
      this.isDrawn = true;
      this.drawTiles(this.itemTilesService.getTiles());
    }
  }

  public disableDrawMode() {
    this.isDrawn = false;
  }

  public setZoomLevelHeights(zoomLevelHeights = null) {
    throw new Error('Not implemented');
  }

  public setSizeScale($scale) {
    throw new Error('Not implemented');
  }
}
